/**
 * Mobilmenyn i vänsterspalten (leftNavigationBlock).
 *
 * Ersätter FrontendSrc/patternlab/js/sidebar-toggle.js, som slutade bundlas när
 * bygget gick från Gulp till Vite. Att skriptet saknades är hela orsaken till att
 * menyn inte gick att öppna - originalets logik var i sig inte trasig på den
 * punkten (_aside.scss sätter `pointer-events: none` på knappens ikoner, så
 * klicket landade alltid på knappen).
 *
 * Rättat i porten:
 *  - `e.target == anchorLinks` jämförde ett element mot en NodeList och kunde
 *    aldrig bli sant, så menyn stängdes inte när man valde en länk i den.
 *  - Escape stänger nu menyn och lämnar tillbaka fokus till knappen.
 *
 * Originalet skrev över `document.onclick`, vilket tar bort alla andra
 * klicklyssnare som råkar använda samma property. Här används addEventListener.
 *
 * Notera att `.sidebar-navigation-overlay` ligger INUTI `.sidebar-navigation` i
 * markupen men renderas som en mörk yta över resten av skärmen. Den måste därför
 * testas före "klick utanför menyn", annars räknas den som en klick inuti menyn
 * och stänger inte.
 */
const OPEN_CLASS = 'mobile-open';

export function initSidebarNavigation(): void {
    const sidebar = document.querySelector<HTMLElement>('.sidebar-navigation');
    if (!sidebar) return;

    const close = (): void => sidebar.classList.remove(OPEN_CLASS);

    document.addEventListener('click', (e: MouseEvent) => {
        const target = e.target as HTMLElement | null;
        if (!target) return;

        if (target.closest('.sidebar-navigation-toggle')) {
            sidebar.classList.toggle(OPEN_CLASS);
            return;
        }

        if (!sidebar.classList.contains(OPEN_CLASS)) return;

        // Bakgrundsytan - ligger i menyn men täcker skärmen utanför den.
        if (target.closest('.sidebar-navigation-overlay')) {
            close();
            return;
        }

        // Länk i menyn: låt navigeringen ske, men stäng menyn.
        if (target.closest('.sidebar-navigation a')) {
            close();
            return;
        }

        if (!target.closest('.sidebar-navigation')) {
            close();
        }
    });

    // Menyn täcker skärmen på mobil och ska gå att lämna med tangentbord
    // (WCAG 2.1.1 Tangentbord, 2.1.2 Ingen tangentbordsfälla).
    document.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Escape' && sidebar.classList.contains(OPEN_CLASS)) {
            close();
            sidebar.querySelector<HTMLElement>('.sidebar-navigation-toggle')?.focus();
        }
    });
}
